import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { solutions as fallbackSolutions } from '../data/siteData';
import { getContentIcon, useCollectionData } from '../services/contentApi';
import './SolutionsPreview.css';

const SolutionsPreview = () => {
  const { items: solutions } = useCollectionData('solutions', fallbackSolutions);

  return (
  <section className="section solutions-preview">
    <div className="container">
      <div className="section-header">
        <div>
          <p className="eyebrow">Facility solutions</p>
          <h2 className="section-title">Supply programs shaped around the facility.</h2>
        </div>
        <p className="section-sub">
          Different care settings need different ordering rhythms, packaging,
          documentation, and patient-comfort standards.
        </p>
      </div>

      <div className="solution-preview-grid">
        {solutions.map((solution, index) => {
          const { title, description, tag, icon, tone } = solution;
          const Icon = getContentIcon(icon);
          const features = Array.isArray(solution.features) ? solution.features : [tag].filter(Boolean);
          return (
            <article className="solution-preview-card stagger-card" key={title || index} style={{ '--delay': `${index * 90}ms` }}>
              <span className={`icon-circle tone-${tone || 'blue'}`}>
                <Icon size={24} strokeWidth={1.8} aria-hidden="true" />
              </span>
              <h3>{title}</h3>
              <p>{description || solution.desc}</p>
              <ul className="check-list">
                {features.slice(0, 2).map((feature) => (
                  <li key={feature}>
                    <CheckCircle size={16} aria-hidden="true" />
                    {feature}
                  </li>
                ))}
              </ul>
              <Link className="text-link" to="/solutions">
                See solution <ArrowRight size={17} aria-hidden="true" />
              </Link>
            </article>
          );
        })}
      </div>
    </div>
  </section>
  );
};

export default SolutionsPreview;
